export enum ViewType {
  Kanban = 'Kanban',
  Tabular = 'Tabular',
  Report = 'Report',
  AdministrationTable = 'AdministrationTable',
  List = 'List',
  EFSBuilder = 'EFSBuilder'
}
